module.exports = __webpack_public_path__ + "img/intro_uk.2bd7af28.svg";